<template>
  <div class="flex-row">
    <input
      type="checkbox"
      :id="filterId"
      name="checkbox-1"
      :checked="getValue"
      @change="(e) => handleChange(e)"
    />
    <label :for="filterId">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "ToggleFilter",
  data() {
    return {
      filterText: "",
    };
  },
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    path: { type: String, default: "" },
    updateMethod: { type: Function },
    filterAction: { type: String, required: false },
    filterKey: { type: String, required: false },
    getValue: Boolean,
  },
  methods: {
    formatDate() {
      alert("");
    },
    handleChange(e) {
      this.$emit("change", e);
      this.$emit("update-filter", {
        id: this.id,
        value: e.target.checked,
        filterAction: this.filterAction,
        filterKey: this.filterKey,
      });
      if (this.updateMethod) {
        this.updateMethod(e.target.checked, this.path);
      }
    },
  },
  computed: {
    filterId: function () {
      return this.id;
    },
    filterLabelId: function () {
      return this.id + "-label";
    },
  },
};
</script>

<style scoped>
.flex-row {
  display: flex;
  align-items: center;
}

label {
  font-weight: 600;
  height: min-content;
}
</style>
